import { useState } from "react";
import { errMsg } from "@/lib/errors";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await signup(email, password, name); toast.success("Welcome to ASFA"); nav("/onboarding"); }
    catch (err) { toast.error(errMsg(err, "Signup failed")); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-9 h-9 rounded-xl bg-slate-950 text-white flex items-center justify-center font-bold">A</div>
          <span className="font-heading font-extrabold text-xl tracking-tight">ASFA</span>
        </Link>
        <div className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
          <h1 className="text-2xl font-bold tracking-tight text-slate-950">Create your account</h1>
          <p className="text-sm text-slate-600 mt-1">Pick a plan and pay to activate your AI receptionist — one-time $100 setup, then monthly.</p>
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="name">Business name</Label>
              <Input data-testid="signup-name" id="name" value={name}
                onChange={(e) => setName(e.target.value)} className="mt-1.5"
                placeholder="Northside Barbers" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input data-testid="signup-email" id="email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input data-testid="signup-password" id="password" type="password" required
                minLength={6} value={password}
                onChange={(e) => setPassword(e.target.value)} className="mt-1.5" />
            </div>
            <Button data-testid="signup-submit" type="submit" disabled={loading}
              className="w-full rounded-xl bg-blue-600 hover:bg-blue-700 h-11">
              {loading ? "Creating..." : "Create account"}
            </Button>
          </form>
          <div className="mt-6 text-sm text-center text-slate-600">
            Already have an account? <Link to="/login" className="text-blue-600 font-medium">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
